<template>
  <div class="detailed-cell">
    <!-- 日期切换 -->
    <div>
      <span @click="onBeforeDateClick" class="usable">{{ "前一" + modelName }}</span>
      <span @click="onDateSpanClick" class="usable">{{ setDateOkText(datePickerValue) }}</span>
      <span @click="onNextDateClick" :class="nextDateClassName">{{ "后一" + modelName }}</span>
    </div>
    <!-- 交易类型列表 -->
    <div v-for="(rows, idx) in table1" :key="idx">
      <div class="inline-cell" v-for="(item, k) in rows" :key="k">
        <div><span>{{ item.date }}</span></div>
        <div><span>{{ item.name | shortText }}</span></div>
      </div>
    </div>
    <mt-datetime-picker ref="datePicker" type="date" v-model="pickerValue" :endDate="new Date()" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm">
    </mt-datetime-picker>
  </div>
</template>

<script>
/* global PUBLIC_SPECIAL_MOBILE */

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetReward } from '@/api/reward';
import { GetUserStatus } from '@/api/user';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'DetailedListExamine',
  props: ['flag', 'mark', 'actived'],
  data() {
    return {
      dataList: [
        { name: '总交易额(元)', date: '0.00' },
        { name: '总交易笔数(笔)', date: '0' },
        { name: '新增代理商(人)', date: '0' },
        { name: '新增商户(人)', date: '0' },
        { name: '终端总数(台)', date: '0' },
        { name: '已激活终端总数(台)', date: '0' },
        { name: 'POS收款交易金额(元)', date: '0.00' },
        { name: 'POS收款交易笔数(笔)', date: '0' },
        { name: '银联云闪付交易金额(元)', date: '0.00' },
        { name: '银联云闪付交易笔数(笔)', date: '0' },
      ],
      table1: [],
      modelName: '天',
      nextDateClassName: 'usable',
      pickerValue: null,
      datePickerValue: null,
      isSpecial: false,
    };
  },
  watch: {
    actived(val) {
      // 判断当前组件是否被激活
      if (this.mark === val) {
        // 获取状态筛选列表数据项
        this.getUserStatus();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      // 判断当前组件是否被激活
      if (this.mark === this.actived) {
        // 获取状态筛选列表数据项
        this.getUserStatus();
      }
    });
  },
  activated() {
    // 加载数据
    this.initData();
  },
  computed: {
    currentSelectedDate() {
      const yyyy = this.datePickerValue.getFullYear();
      const MM = String(this.datePickerValue.getMonth() + 1).padStart(2, '0');
      const dd = String(this.datePickerValue.getDate()).padStart(2, '0');
      return yyyy + '-' + MM + '-' + dd + ' 00:00:00';
    },
    prevPageSelectedFlag() {
      return parseInt(this.flag);
    },
    parentSelectedMark() {
      return this.mark;
    },
  },
  methods: {
    getUserStatus() {
      Indicator.open();
      GetUserStatus()
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            const mobile = res.data.mobile;
            for (let i = 0; i < PUBLIC_SPECIAL_MOBILE.length; i++) {
              if (PUBLIC_SPECIAL_MOBILE[i] === mobile) {
                this.isSpecial = true;
                break;
              }
            }
            // 设置默认日期为当前日期
            this.datePickerValue = new Date();
            // 设置时间间隔
            this.modelName = this.mark === 1 ? '天' : '月';
            // 设置下一天/下一月按钮样式
            this.setNextDateClassName();
            // 加载数据
            this.initData();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
          // 设置默认日期为当前日期
          this.datePickerValue = new Date();
          // 设置时间间隔
          this.modelName = this.mark === 1 ? '天' : '月';
          // 设置下一天/下一月按钮样式
          this.setNextDateClassName();
          // 加载数据
          this.initData();
        });
    },
    getReward() {
      Indicator.open();
      GetReward({
        date: this.currentSelectedDate,
        flag: this.prevPageSelectedFlag,
        mark: this.parentSelectedMark,
      })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.dataList = res.rows;
            this.dataRebuild();
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    dataRebuild() {
      const len = this.dataList.length;
      const n = 2;
      const lineNum = len % n === 0 ? len / n : Math.floor(len / n + 1);
      this.table1 = [];
      for (let i = 0; i < lineNum; i++) {
        const obj = this.dataList.slice(i * n, i * n + n);
        if (this.isSpecial) {
          if (
            obj[0].name !== '团队新增伙伴(人)' &&
            obj[0].name !== '直推伙伴(人)' &&
            obj[0].name !== '有效商户数(人)' &&
            obj[0].name !== '商户总数(人)' &&
            obj[0].name !== '代理总数(人)' &&
            obj[0].name !== '直推商户总数(人)' &&
            obj[0].name !== '直推有效商户数(人)' &&
            obj[0].name !== '直推代理总数(人)'
          ) {
            this.table1.push(JSON.parse(JSON.stringify(obj)));
          }
        } else {
          this.table1.push(JSON.parse(JSON.stringify(obj)));
        }
      }
    },
    initData() {
      // 判断接口开关
      switch (this.$store.state.INTERFACE_ON_OFF) {
        case 'on':
          this.getReward();
          break;
        case 'off':
          this.dataRebuild();
          break;
      }
    },
    setDateOkText(val) {
      if (val) {
        if (this.mark === 1) return val.getFullYear() + '年' + (val.getMonth() + 1) + '月' + val.getDate() + '日';
        else if (this.mark === 2) return val.getFullYear() + '年' + (val.getMonth() + 1) + '月';
      }
      return '';
    },
    openDatePicker() {
      this.pickerValue = this.datePickerValue;
      this.$refs.datePicker.open();
      if (this.mark === 2) {
        this.$refs.datePicker.$el.getElementsByClassName('picker-slot')[2].style.display = 'none';
      }
    },
    onDateSpanClick() {
      this.openDatePicker();
    },
    onDatePickerConfirm(val) {
      this.datePickerValue = val;
      this.setNextDateClassName();
      this.initData();
    },
    onBeforeDateClick() {
      const d = new Date(this.datePickerValue);
      if (this.mark === 1) this.datePickerValue = new Date(d.setDate(d.getDate() - 1));
      else if (this.mark === 2) this.datePickerValue = new Date(d.setMonth(d.getMonth() - 1, 1));
      this.setNextDateClassName();
      this.initData();
    },
    onNextDateClick() {
      if (this.nextDateClassName === 'usable') {
        const d = new Date(this.datePickerValue);
        if (this.mark === 1) this.datePickerValue = new Date(d.setDate(d.getDate() + 1));
        else if (this.mark === 2) this.datePickerValue = new Date(d.setMonth(d.getMonth() + 1, 1));
        this.setNextDateClassName();
        this.initData();
      }
    },
    setNextDateClassName() {
      const nowTime = new Date();
      const dateTime = new Date(this.datePickerValue);
      if (this.mark === 1) this.nextDateClassName = nowTime.getDate() === dateTime.getDate() ? 'unusable' : 'usable';
      else if (this.mark === 2) {
        this.nextDateClassName = nowTime.getMonth() === dateTime.getMonth() ? 'unusable' : 'usable';
      }
    },
  },
  filters: {
    shortText(val) {
      if (val.length > 12) return val.substring(0, 12) + '…';
      return val;
    },
  },
};
</script>
